// extracted by mini-css-extract-plugin
module.exports = {"section":"_2z9_NLDRaKHTxhXT9tOKNQ","container":"_35CM2eOufdVx8FBpQjqKIP"};